/**
 * Cihaz kimligi.
 *
 * Sunucu YENILEME JETONUNU BU KIMLIGE BAGLAR: baska bir cihaz kimligiyle
 * sunulan bir yenileme jetonu hirsizlik sayilir ve kullanicinin TUM oturumlari
 * dusurulur (bkz. iam-management/src/utils/token.js -> TOKEN_HIJACK_DETECTED).
 * Bu yuzden kimlik kurulum boyunca SABIT kalmali ve her istekte `x-device-id`
 * ile gonderilmelidir.
 *
 * Kaybedilmesi (depolama temizligi, gizli sekme) kabul edilebilir bir sonuc
 * uretir: yenileme jetonu artik kullanilamaz, kullanici yeniden giris yapar.
 * Kabul EDILEMEZ olan, her sekmede/istekte farkli bir kimlik uretmektir — o
 * durumda ilk yenileme denemesi hirsizlik gibi gorunur ve oturumu oldurur.
 */

export const DEVICE_ID_STORAGE_KEY = 'kural.deviceId';

// Sekme omru boyunca tek deger. Depolama yazilamiyorsa (gizli kip) bu degisken
// yine de sabit kalir; oturum o sekme kapanana kadar tutarli calisir.
let cached: string | null = null;

const randomId = (): string => {
  // randomUUID yalniz guvenli baglamda (https / localhost) tanimli. Degilse
  // kimligin kriptografik olmasi gerekmiyor — yalniz benzersiz ve sabit.
  const webCrypto = globalThis.crypto as Crypto | undefined;
  if (webCrypto && typeof webCrypto.randomUUID === 'function') {
    return webCrypto.randomUUID();
  }
  return `kural-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

const readStored = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  } catch {
    // Gizli kip / depolama kapali: okuma bile atabiliyor.
    return null;
  }
};

const writeStored = (value: string): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, value);
  } catch {
    /* yok sayilir — bkz. yukaridaki not */
  }
};

/** Kurulumun cihaz kimligi; ilk cagrida uretilip kalici olarak yazilir. */
export const getDeviceId = (): string => {
  if (cached) return cached;
  const stored = readStored();
  if (stored) {
    cached = stored;
    return cached;
  }
  cached = randomId();
  writeStored(cached);
  return cached;
};

/** YALNIZ TESTLER ICIN: modul ici onbellegi bosaltir. */
export const resetDeviceIdCache = (): void => {
  cached = null;
};
